import { useCallback, useMemo } from 'react';
import { useReactRedux } from '@applyboard/ab-common';
import buildObjectListCached from "../util/buildObjectListCached";
var useApiObjectList = function useApiObjectList(objectType, filter, props) {
  if (typeof objectType !== 'string') {
    throw new TypeError('getApiObjectList: first parameter must be a string');
  }
  if (objectType.length <= 0) {
    throw new Error('getApiObjectList: first parameter must be a non-empty string');
  }
  if (filter && typeof filter !== 'function') {
    throw new TypeError('getApiObjectLit: if filter parameter is defined, it should be a function.');
  }
  var cachedBuilder = useCallback(buildObjectListCached(objectType), [objectType]);
  var mapStateToProps = useCallback(function (state) {
    var data = state && state.api ? cachedBuilder(state) : [];
    return {
      data: data
    };
  }, [cachedBuilder]);
  var state = useReactRedux(mapStateToProps, null, props);
  var returnData = useMemo(function () {
    return filter ? filter(state.data, props) : state.data;
  }, [state.data, filter]);
  return returnData;
};
export default useApiObjectList;